// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"032b26b2","51":"bfe6e2c2","103":"30d19c61","588":"30d19c61","624":"81c9976d","679":"30d19c61","710":"bf0d36ea","720":"032b26b2","765":"1a04e66d","855":"bf0d36ea"}[chunkId] + ".chunk.css";
};